export default __webpack_public_path__ + "static/media/BrandonGrotesque-Black.564b5758.woff2";